import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCalendarStart = props => (
  <SvgIcon {...props} viewBox="0 0 14 16">
    <path d="m7.0001 7.1111h-3.5v3.5556h3.5v-3.5556zm3.1109-7.1111v1.6h-6.2222v-1.6h-1.5556v1.6h-0.77778c-0.86313 0-1.5476 0.72-1.5476 1.6l-0.0078 11.2c0 0.88 0.69222 1.6 1.5556 1.6h10.889c0.85556 0 1.5556-0.72 1.5556-1.6v-11.2c0-0.88-0.7-1.6-1.5556-1.6h-0.77778v-1.6h-1.5556zm2.1389 14.222h-10.5v-8.8889h10.5v8.8889z" />
  </SvgIcon>
);

export default IconCalendarStart;



// WEBPACK FOOTER //
// ./src/components/icons/IconCalendarStart.js